<template>
    <v-card width="100%">
        <v-card-title>
            <v-row class="pl-3 pt-3">
                <v-col cols="auto">
                    <v-select label="Выберите жанр" :items="selectType" item-text="name" item-value="type" width="150px"
                              @change="getTop" v-model="selectedType"/>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row align-content="center" justify="center" class="pl-3">
                <v-progress-circular v-if="overlay" indeterminate size="64"></v-progress-circular>
                <v-card v-else @click="openDetail(top.id)" max-width="210" v-for="(top) in topData" :key="top.id"
                        class="xs4 md3 lg2 mt-3">
                    <v-img v-if="!top.img.indexOf('http')" max-height="200px" contain
                           :src="top.img"/>
                    <v-img v-else-if="src.find(x => x.id === top.id)" max-height="200px" contain
                           :src="src.find(x => x.id === top.id).image"/>
                    <v-img v-else max-height="200px" min-height="200px">
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"/>
                        </v-row>
                    </v-img>
                    <v-card-subtitle>{{ top.title.substr(0, 45).split(/ (?=\S+$)/)[0] }}</v-card-subtitle>
                </v-card>
            </v-row>
            <detail-torrent ref="detailTorrent"/>
            <v-btn v-scroll="onScroll" class="mb-8" v-show="fab" fab dark fixed bottom left @click="toTop">
                <v-icon>mdi-arrow-up-bold-circle</v-icon>
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import detailTorrent from "@/components/detailTorrent";

export default {
    name: "topKinozal",
    components: {detailTorrent},
    data() {
        return {
            fab: false,
            overlay: false,
            src: [],
            topData: [],
            selectType: [
                {name: 'Все', type: 'all'}, {name: 'Комедии', type: 'comedy'}, {
                    name: 'Фантастика',
                    type: 'fantasy'
                }, {name: 'Ужасы', type: 'horror'},
                {name: 'Триллеры', type: 'thriller'}, {name: 'Драма', type: 'drama'}, {
                    name: 'Приключения',
                    type: 'action'
                }, {name: 'Боевик', type: 'army'},
                {name: 'Наше кино', type: 'russian'}
            ],
            selectedType: 'all'
        }
    },
    methods: {
        onScroll(e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset || e.target.scrollTop || 0
            this.fab = top > 20
        },
        toTop() {
            this.$vuetify.goTo(0)
        },
        /**
         *
         * @param id
         */
        openDetail(id) {
            this.$refs.detailTorrent.getDetail(id)
        },
        /**
         *
         * @returns {Promise<void>}
         */
        async getTop() {
            this.overlay = true
            this.topData = []
            await this.$http.post('/getTop', {type: this.selectedType}).then(async (top) => {
                this.topData = top.data
                this.overlay = false
            })
            for (let video of this.topData) {
                if (video.img.indexOf('http') === -1) {
                    await this.image(video.img, video.id)
                }
            }
        },
        /**
         *
         * @param route
         * @param ind
         * @returns {Promise<void>}
         */
        image(route, ind) {
            this.$http.post('/getTopImage', {route: route}, {
                responseType: 'blob'
            }).then((resp) => {
                let reader = new FileReader()
                reader.readAsDataURL(resp.data)
                reader.onload = () => {
                    this.src.push({image: reader.result, id: ind})
                }
            })
        }
    },
    created() {
        this.getTop()
    }
}
</script>

<style scoped>

</style>
